// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Xq-z","breadcrumbForward":"Yq-z","breadcrumbBack":"Zq-z","selected":"_q-z"};